/**
 * Determines and controls the density of ads.
 */
function ANDensityManager(mainContent, zoneDelegate, repeatableZone, logger = null){

    if(!zoneDelegate || !(zoneDelegate instanceof ANZoneDelegate)){
        
        throw new Error('Invalid zoneDelegate, expected an ANZoneDelegate.');
    }

    if(!repeatableZone){
        
        throw new Error('Unable to find repeatable zone.');
    }

    this.__initialized                                     = false;
    this.__repeatableZone                                  = repeatableZone;
    this.__logger                                          = logger || new AdsNinjaLogger();
    this.__zoneDelegate                                    = zoneDelegate;
    this.__mainContent                                     = mainContent;
    this.__estimatedScrollHeight                           = 0;
    var repeatableOptions                                  = this.__repeatableZone.getRepeatableSettings();
    this.__targetDensity                                   = repeatableOptions.density;
    this.__safeTargetDensity                               = window.adsNinja.utils.roundUpToTwoDecimalPoints(Math.max(this.__targetDensity - 0.01, 0.01));
    this.__projectedDensity                                = 0;
    this.__includeStickyUnits                              = repeatableOptions.includeStickyUnitsInDensity || false;
    this.__minimumPixelDistanceBetweenZones                = 0;
    this.__maxNumberOfZonesToInject                        = 0;
    this.__repeatableAdSpace                               = 0;
    this.__lastBaseScrollHeight                            = 0;
    this.__lastScrollHeight                                = 0;
    this.__startingAdIndex                                 = null;
    this.__densityStrategy                                 = null;
    this.__zoneElementsToIgnore                            = {};
    this.__zoneHeights                                     = {};
    this.__isZoneInParentThatNeedNotBeConsideredDictionary = {};
    this.__isZoneInMainContentDictionary                   = {};
    this.__initialNumberOfZonesOnPage                      = 0;

    if(!this.__mainContent || !(this.__mainContent instanceof HTMLElement)){
        
        throw new Error('Invalid mainContent, expected an HTMLElement.');
    }

    if(!this.__targetDensity || typeof this.__targetDensity !== 'number'){

        throw new Error('Invalid targetDensity, expected a number.');
    }

    if(!repeatableOptions.densityStrategy || !repeatableOptions.densityStrategy.id){
        
        throw new Error('Invalid densityStrategy, expected an object.');
    }

    repeatableOptions.elementsToIgnore                   = repeatableOptions.elementsToIgnore || [];
    this.__isZoneInParentThatNeedNotBeConsideredSelector = '';
    this.__excludeFromScrollHeightCalculationSelector    = '';
    
    repeatableOptions.elementsToIgnore.forEach(function(elementToIgnore){ 
        
        if(elementToIgnore.ignoreInDensityCalculation){

            if(this.__isZoneInParentThatNeedNotBeConsideredSelector){
                
                this.__isZoneInParentThatNeedNotBeConsideredSelector += ', ';
            }
                
            this.__isZoneInParentThatNeedNotBeConsideredSelector += elementToIgnore.selector;
        }

        if(elementToIgnore.ignoreInHeightCalculation){

            if(this.__excludeFromScrollHeightCalculationSelector){
                
                this.__excludeFromScrollHeightCalculationSelector += ', ';
            }
                
            this.__excludeFromScrollHeightCalculationSelector += elementToIgnore.selector;
        }
    }, this);

    var idDensityStrategy = (repeatableOptions.densityStrategy && typeof repeatableOptions.densityStrategy === 'object') ? repeatableOptions.densityStrategy.id : 1;

    switch(idDensityStrategy){

        case 2:

            this.__densityStrategy = new AdsNinjaDensityStrategyLeanTop();

            break;

        case 3:

            this.__densityStrategy = new AdsNinjaDensityStrategyLeanBottom();

            break;

        default:

            this.__densityStrategy = new AdsNinjaDensityStrategy();

            break;
    }
}

/**
 * Initialize.
 */
ANDensityManager.prototype.initialize = function(){
    
    if(this.__initialized){
        
        return;
    }

    this.recalculate();
};

/**
 * Recalculates the density.
 * 
 * @returns {object}
 */
ANDensityManager.prototype.recalculate = function(){
  
    this.__initialized                      = true;
    this.__estimatedScrollHeight            = this.__calculateScrollHeight();
    this.__maxNumberOfZonesToInject         = 0;
    this.__minimumPixelDistanceBetweenZones = 0;
    this.__repeatableAdSpace                = 0;
    var adIndex                             = this.__startingAdIndex || 1;
    this.__startingAdIndex                  = null;
    // this.__initialNumberOfZonesOnPage       = this.__zoneDelegate.getNumberOfZones();
    var injectedAdSpace                     = 0;
    var floatingAdSpace                     = 0;
    var zonesWithFloatingUnits              = [];

    if(this.__includeStickyUnits){

        // Get all floating ads from the zone delegate.
        zonesWithFloatingUnits = this.__zoneDelegate.getFloatingZones();

        for(var x in zonesWithFloatingUnits){

            var zone        = zonesWithFloatingUnits[x];
            var zoneElement = zone.getElement();

            // Dedupe zones from those that are in the main content, are not in-stream video, and already injected.
            if(!zoneElement || zone.isInstreamVideo() || this.__isZoneInMainContent(zone, zoneElement)){

                continue;
            }

            var totalAdSpace           = zone.calculateEstimatedAdSpace(true);
            var adSpaceWithoutFloating = zone.calculateEstimatedAdSpace(false);
            floatingAdSpace            += totalAdSpace - Math.max(totalAdSpace - adSpaceWithoutFloating, 0);
        }
    }

    // Calculate height of ad zones already in the main content, with exclusions.
    var injectedZoneElements = this.__mainContent.querySelectorAll('.an-zone'); 

    if(injectedZoneElements && injectedZoneElements.length > 0){

        for(var i = 0; i < injectedZoneElements.length; i++){

            var zoneElement = injectedZoneElements[i];

            var key = zoneElement.dataset.key;

            if(!key){

                this.__logger.error('Unable to find key for zone element.', {
                    zoneElement: zoneElement
                });

                continue;
            }

            var zone = this.__zoneDelegate.get(key);

            if(!zone){

                this.__logger.error('Unable to find zone for key.', {
                    key: key
                });

                continue;
            }

            // Exclude instream videos and ads in sections we don't need to calculate.
            if(zone.isInstreamVideo() || this.__isZoneInParentThatNeedNotBeConsidered(zone, zoneElement)){

                continue;
            }

            // TODO: Handle zones taking up the exact same floating space.
            
            // Current ad space vs estimated ad space.
            // If the estimated ad space is greater than the current ad space, add the difference to the scroll height.
            var injectedZoneEstimatedAdSpace = window.adsNinja.utils.roundUpToTwoDecimalPoints(zone.calculateEstimatedAdSpace(this.__includeStickyUnits));
            injectedAdSpace                  += injectedZoneEstimatedAdSpace;
            var injectedZoneCurrentAdSpace   = window.adsNinja.utils.roundUpToTwoDecimalPoints(zone.calculateCurrentAdSpace(this.__includeStickyUnits));
            this.__estimatedScrollHeight     += (injectedZoneEstimatedAdSpace > injectedZoneCurrentAdSpace) ? injectedZoneEstimatedAdSpace - injectedZoneCurrentAdSpace : 0; 
        }
    }

    // Calculate the total space left for ads.
    var totalAdSpaceInUse = injectedAdSpace + floatingAdSpace;
    var density           = window.adsNinja.utils.roundUpToTwoDecimalPoints(totalAdSpaceInUse / this.__estimatedScrollHeight);

    if(density >= this.__targetDensity){

        this.__logger.info('Recalculated density manager.', {
            targetDensity: this.__targetDensity,
            currentDensity: density,
            projectedDensity: this.__projectedDensity,
            currentSpaceInUse: totalAdSpaceInUse,
            spaceForMoreZones: this.__repeatableAdSpace,
            maxNumberOfZonesToInject: this.__maxNumberOfZonesToInject,
            estimatedScrollHeight: this.__estimatedScrollHeight,
            projectedScrollHeight: this.__estimatedScrollHeight + this.__repeatableAdSpace, 
            minimumPixelDistanceBetweenZones: this.__minimumPixelDistanceBetweenZones,
            numberOfZonesInMainContent: injectedZoneElements.length || 0,
            numberOfZonesWithFloatingUnits: zonesWithFloatingUnits.length || 0,
        }, false);

        return;
    }

    var projectedRepeatableAdSpace = 0;
    var repeatableZoneInstances    = 0;
    var repeatableZoneInstance     = null;
    var projectedDensity           = this.__projectedDensity || 0;

    do{

        this.__projectedDensity         = projectedDensity;
        this.__maxNumberOfZonesToInject = repeatableZoneInstances;
        this.__repeatableAdSpace        = projectedRepeatableAdSpace;
        repeatableZoneInstance          = this.__zoneDelegate.getRepeatableZoneInstance(this.__repeatableZone, adIndex);

        if(repeatableZoneInstance && !repeatableZoneInstance.hasBeenAddedToPage()){

            repeatableZoneInstances    += 1;
            projectedRepeatableAdSpace += repeatableZoneInstance.calculateEstimatedAdSpace();
        }
        else if(!repeatableZoneInstance){

            throw new Error('Unable to find repeatable zone instance.');
        }

        adIndex          += 1;
        projectedDensity = window.adsNinja.utils.roundUpToTwoDecimalPoints((projectedRepeatableAdSpace + totalAdSpaceInUse) / (this.__estimatedScrollHeight + projectedRepeatableAdSpace));
    }
    while(this.__targetDensity > projectedDensity);

    this.__minimumPixelDistanceBetweenZones = window.adsNinja.utils.roundUpToTwoDecimalPoints(this.__repeatableAdSpace / this.__maxNumberOfZonesToInject);

    // Returns spacing between zones and max number of zones.
    this.__logger.info('Recalculated density manager.', {
        targetDensity: this.__targetDensity,
        currentDensity: density,
        projectedDensity: this.__projectedDensity,
        currentSpaceInUse: totalAdSpaceInUse,
        spaceForMoreZones: this.__repeatableAdSpace,
        maxNumberOfZonesToInject: this.__maxNumberOfZonesToInject,
        estimatedScrollHeight: this.__estimatedScrollHeight,
        projectedScrollHeight: this.__estimatedScrollHeight + this.__repeatableAdSpace, 
        minimumPixelDistanceBetweenZones: this.__minimumPixelDistanceBetweenZones,
        numberOfZonesInMainContent: injectedZoneElements.length || 0,
        numberOfZonesWithFloatingUnits: zonesWithFloatingUnits.length || 0,
    }, false);
};

/**
 * Determine distance between zones.
 * 
 * @param {number} adNumber 
 * @param {number} currentPageDepth 
 * @returns {number}
 */
ANDensityManager.prototype.determineDistanceBetweenZones = function(adNumber, currentPageDepth){
    
    if(null === this.__startingAdIndex){

        this.__startingAdIndex = adNumber;
    }

    // // Keep track of how many zones were already injected to see if we need to recalculate.
    // if(this.__initialNumberOfZonesOnPage + (adNumber - this.__startingAdIndex) - 1 > this.__zoneDelegate.getNumberOfZones()){

    //     this.__logger.info('Recalculating density manager because more zones were injected than expected.');
    //     this.recalculate();
    // }

    var numberOfAdsLeftToInject = this.__maxNumberOfZonesToInject + this.__startingAdIndex - adNumber;

    if(numberOfAdsLeftToInject <= 0){

        return null;
    }

    var percentageOfExpectedHeightProcessed = currentPageDepth / this.__calculateScrollHeight();
    var relativeSpaceLeftToInjectAdsIn      = this.__estimatedScrollHeight * (1 - percentageOfExpectedHeightProcessed);

    return this.__densityStrategy.determineDistanceBetweenZones(numberOfAdsLeftToInject, relativeSpaceLeftToInjectAdsIn, this.__minimumPixelDistanceBetweenZones);
};

/**
 * Returns true if the zone is in a parent element that should not be considered.
 * 
 * @param {Object} zone
 * @param {Object} zoneElement 
 * @returns {boolean}
 */
ANDensityManager.prototype.__isZoneInParentThatNeedNotBeConsidered = function(zone, zoneElement){

    if(!zone || !zoneElement || !(zoneElement instanceof HTMLElement)){

        throw new Error('Invalid zone or zone element.');
    }
    else if(!this.__isZoneInParentThatNeedNotBeConsideredSelector || !zoneElement.parentElement){

        return false;
    }

    var key = zone.getKey();

    if(this.__isZoneInParentThatNeedNotBeConsideredDictionary.hasOwnProperty(key)){

        return this.__isZoneInParentThatNeedNotBeConsideredDictionary.hasOwnProperty[key];
    }

    var zoneParentElement = zoneElement.parentElement;

    // Exclude ads that are in sections we don't need to calculate.
    while(zoneParentElement && zoneParentElement != this.__mainContent){

        if(zoneParentElement.matches(this.__isZoneInParentThatNeedNotBeConsideredSelector)){

            this.__isZoneInParentThatNeedNotBeConsideredDictionary[key] = true;

            return true;
        }

        zoneParentElement = zoneParentElement.parentElement;
    }

    this.__isZoneInParentThatNeedNotBeConsideredDictionary[key] = false;

    return false;
};

/**
 * Returns true if the zone is in a parent element that should not be considered.
 * 
 * @param {Object} zone
 * @param {Object} zoneElement 
 * @returns {boolean}
 */
ANDensityManager.prototype.__isZoneInMainContent = function(zone, zoneElement){

    if(!zone || !zoneElement || !(zoneElement instanceof HTMLElement)){

        throw new Error('Invalid zone or zone element.');
    }

    var key = zone.getKey();

    if(this.__isZoneInMainContentDictionary.hasOwnProperty(key)){

        return this.__isZoneInMainContentDictionary.hasOwnProperty[key];
    }

    var zoneParentElement = zoneElement.parentElement;

    while(zoneParentElement && zoneParentElement != this.__mainContent){

        zoneParentElement = zoneParentElement.parentElement;
    }

    this.__isZoneInMainContentDictionary[key] = (zoneParentElement == this.__mainContent);

    return this.__isZoneInMainContentDictionary[key];
};

/**
 * Returns how many zones are on the page.
 * 
 * @returns {number}
 */
ANDensityManager.prototype.__calculateScrollHeight = function(){

    var scrollHeight = this.__mainContent.scrollHeight;

    if(this.__lastBaseScrollHeight > 0 && scrollHeight){

        return this.__lastScrollHeight;
    }

    if(this.__excludeFromScrollHeightCalculationSelector){

        var elements = this.__mainContent.querySelectorAll(this.__excludeFromScrollHeightCalculationSelector);

        for(var i = 0; i < elements.length; i++){

            scrollHeight -= elements[i].scrollHeight;
        }
    }

    this.__lastScrollHeight = scrollHeight;

    return this.__lastScrollHeight;
};

window.ANDensityManager = ANDensityManager;